import { createPinia } from 'pinia';
import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player';
import VueZoomer from 'vue-zoomer';
import { createDeviceDetector } from 'next-vue-device-detector';
import VueGtag from 'vue-gtag-next';
import InitService from '@/services/InitService';
import localization from '@/plugins/localization';
import installElementPlus from '@/plugins/element';
import installTouchEvent from '@/plugins/touch-events';
import LocalStorageService from '@/services/LocalStorageService';
import AppTakePhoto from '@/components/AppTakePhoto.vue';
import MoveToPopUp from '@/components/BottomPopUp/PopUpTypes/MoveTo/MoveToPopUp.vue';
import MixedMediaPopUp from '@/components/BottomPopUp/PopUpTypes/MixedMediaPopUp.vue';
import AppSoloCaseSelector from '@/components/AppSoloCaseSelector.vue';
import UploadPhotosPopUp from '@/components/BottomPopUp/PopUpTypes/Upload/UploadPhotosPopUp.vue';
import DrivePhotoCarousel from '@/modules/drive/components/DrivePhotoCarousel.vue';
// import installVimeoPlayer from '@/plugins/vimeo-player';
import App from './App.vue';
import router from './router';
// import store from './vx-store';

import 'normalize.css';
import 'element-plus/dist/index.css';
// import './assets/fonts/fonts.css';
import './styles/common.sass';

import './styles/icons/style.css';
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css';
import MonitoringService from './services/MonitoringService';
import { PERFORMANCE_MONITORING_STEPS } from './types/enums';
import ItemCase from '@/modules/drive/components/items/ItemCase.vue';

import './sass-template/content/css/styles.css';

const device = createDeviceDetector();

const app = createApp(App);

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'preprod') {
  Sentry.init({
    app,
    dsn: 'https://e13d0562956e45f0be14d692f592a011@o1057060.ingest.sentry.io/4504407178543104',
    environment: process.env.NODE_ENV,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    ignoreErrors: [
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
    ],
    tracesSampleRate: 1.0,
  });
}

app.component('app-take-photo', AppTakePhoto);
app.component('move-to-pop-up', MoveToPopUp);
app.component('mixed-media-pop-up', MixedMediaPopUp);
app.component('app-solo-case-selector', AppSoloCaseSelector);
app.component('upload-photos-pop-up', UploadPhotosPopUp);
app.component('drive-photo-carousel', DrivePhotoCarousel);
app.component('item-case', ItemCase);

app
  // .use(store)
  .use(createPinia())
  .use(router)
  .use(localization)
  .use(installElementPlus)
  .use(installTouchEvent)
  .use(Vue3VideoPlayer)
  .use(VueZoomer)
  .use(device)
  .use(VueGtag, {
    property: {
      id: LocalStorageService.getGmtId(),
    },
  }, router)
  .mount('#app');

InitService.init();

MonitoringService.sendMonitoringStep(PERFORMANCE_MONITORING_STEPS.VUE_INSTANCE_MOUNTED, performance.now());
